import styled from "@emotion/styled"
import { gridGap, spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { useIntl } from "react-intl"
import { Grid, GridItem, Input, MultiSelect, Skeleton } from "src/components"
import { selectCatalogExteriorColorMessages } from "./selectCatalogExteriorColor.messages"

export const SelectCatalogExteriorColorSkeleton = () => {
	const { formatMessage } = useIntl()

	return (
		<>
			<StyledGrid $rowGap={gridGap}>
				<GridItem size={{ base: 12, s: 4 }}>
					<MultiSelect
						name="tag"
						options={[]}
						label={formatMessage(selectCatalogExteriorColorMessages.tag)}
						disabled
					/>
				</GridItem>
				<GridItem size={{ base: 12, s: 4 }}>
					<MultiSelect
						name="colorType"
						options={[]}
						label={formatMessage(selectCatalogExteriorColorMessages.colorType)}
						disabled
					/>
				</GridItem>
				<GridItem size={{ base: 12, s: 4 }}>
					<Input name="searchText" type="search" disabled />
				</GridItem>
			</StyledGrid>
			<Skeleton.Table
				caption="Select Catalog Exterior Color List"
				headings={[
					selectCatalogExteriorColorMessages.name,
					selectCatalogExteriorColorMessages.code,
					selectCatalogExteriorColorMessages.colorType,
				]}
				rows={6}
			/>
		</>
	)
}

const StyledGrid = styled(Grid)`
	align-items: flex-end;
	margin-bottom: ${spacingStaticMd};
`
